import React, { useEffect, useState } from 'react';
import { styled } from 'styled-components';
import theme from '../../../styles/theme';
import moment from "moment";
import { sampleData } from "../SampleData";
import { useGetProjectSchedule } from '../../../interfaces/dashboard';
import AlertMark from '../AlertMark';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import ProjectStatusLabel from '../../common/ProjectStatusLabel2';
import 'moment/locale/ko';

const TitleLine = styled.ul`
    list-style-type: none;
    padding:0;
    padding: 0 0.4rem;
    margin:0;
    li {
        font-size: 1.25rem;
        font-weight: 600;
        height: 2.5rem;
        display: grid;
        // grid-template-columns: minmax(1rem,auto) 10rem 4rem 4rem 8rem 5rem 5rem 12rem 5rem 12rem 8rem 6rem;
        // SJK
        grid-template-columns: minmax(1rem,auto) 10rem 6rem 4rem 8rem 4rem 7rem 18rem 6rem 10rem 7rem 6rem;
        gap:0;
        div:nth-child(1){
            text-align: left;
            padding-left: 8px;
        }
        div:nth-child(2), div:nth-child(3){
            text-align: center;
        }
    }
    li:first-child {
        div {
            display: block;
            text-align: center;
        }
        border-bottom:3px solid ${theme.color.black[80]};
    }
`; 
const SliderWrap = styled.div`
    width: 100%;
    height: calc(3.4rem * 12 + 0.7rem);
    // min-height: calc(3.4rem * 12 + 0.7rem);
    // max-height: calc(3.4rem * 12 + 0.7rem);
    .slick-track{
        height: inherit !important;
    }
`;

const DescArea = styled.ul`
    list-style-type: none;
    padding: 0 0.4rem 0;
    margin:0;
    color: #000000;
    min-height: calc(3.4rem * 12 + 0.7rem);
    li {
        position: relative;
        margin: 0;
        line-height: 2rem;
        font-size: 1.25rem;
        // font-weight: bold;
        height: 3.4rem;
        display: grid;
        // grid-template-columns: minmax(1rem,auto) 10rem 4rem 4rem 8rem 5rem 5rem 12rem 5rem 12rem 8rem 6rem;
        // SJK
        grid-template-columns: minmax(1rem,auto) 10rem 5rem 4rem 8rem 4rem 7rem 18rem 6rem 10rem 7rem 6rem;
        gap:0;
        border-top: 2px solid #dfddd9;
        div {
            position: relative;
        }
        .title_line {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            gap: 8px;
            
        }
        .titleEl {
            // width: 40%;
            // display: block;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
        }
        .align {
            display: flex;
            justify-content: center;
            align-items: center;
        }
        // .align_twoLine {
        //     display: flex;
        //     justify-content: center;
        //     align-items: center;
        //     flex-direction: column;
        //     // font-weight: bold;
        //     font-size: 1.1rem;
        //     line-height: 1.3rem;
        //     span {
        //         font-size: 1.1rem;
        //         line-height: 1.4rem;
        //     }
        // }
        // SJK: 20240816
        .align_twoLine {
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            text-align: center;
            font-size: 1.0rem;
            line-height: 1.1rem;
            span {
                font-size: 1.0rem;
                line-height: 1.1rem;
            }
        }
        // SJK: 20240816
        .align_Between {
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            // font-weight: bold;
            font-size: 1.1rem;
            line-height: 1.3rem;
            span {
                font-size: 1.1rem;
                line-height: 1.4rem;
            }
        }
        
    }
    li:first-child {
        margin-top: 0.7rem;
    }
    li:last-child {
        border-bottom: 2px solid #dfddd9;
    }
    .alertLi{
        border-top: 2px solid #e2614d;
        background: #faeeea;
    }
`;
const BarBox = styled.div`
    // margin: 0px 10px;
    padding:0;
    width: 90%;
    height: 2rem;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    background: #dfddd9;
`;

const BarStyle = styled.div`
    margin:0;padding:0;
    width: calc(5% + ${(props)=>props.size ? props.size : '0'}%);
    min-width: 5%;
    max-width: 100%;
    // height: 2rem;
    background: ${theme.color.coding2};
    display: flex;
    justify-content: flex-start;
    align-items: center;
    border: 0;
    span {
        display: inline-block;
        margin:0;
        padding-left: 8px;
        font-size: 1.2rem;
        white-space: nowrap;
    }
    transition: all 1000ms ease-in-out, transform 1000ms ease-in-out;
`;

const ScheduleList2 = () => {

    // const [dateArray, setDateArray] = useState();
    const [list, setList] = useState();
    // const [list, setList] = useState(sampleData.slice(0,12));
    const [list2, setList2] = useState(sampleData.slice(12,sampleData.length));
    const {data} = useGetProjectSchedule();

    const setting = {
        infinite: true,
        speed: 1000,
        autoplay: true,
        autoplaySpeed: 10000,
        arrows:false,
        vertical: true,
        dots: true
    }

    useEffect(()=>{
        if(data){
            const temp = data.map((item,index)=>{
                const codingTemp = moment().isBetween(item.coding_from,item.coding_to+' 23:59:59',undefined,'[]')
                return {
                    ...item,
//                    rec_list:item.rec_list.split(','),    
                    rec_list:item.rec_list.split('\n'),     //SJK: 20240816
                    set_person:item.set_person.split(','),
                    alert:(item.alert_msg!==null && item.alert_msg!=='')?true:false,
                    coding_progress: codingTemp ? 100 - (moment(item.coding_to).add(1,'days').diff(moment(),'days')*10):0
                }
            })
            if(temp.length > 12){
                var tempArr = [];
                for(var x=0;x<temp.length;x+=12 ){
                    tempArr.push(temp.slice(x,x+12));
                }
                setList(tempArr);
            }else{
                setList([temp])
            }
            
        }
    },[data])
    // useEffect(()=>{
    //     console.log(list)
    // },[list])
    // useEffect(()=>{
    //     if(data){
    //         const temp = data.map((item,index)=>{
    //             const temp = item.inst_nm_list !== null ? item.inst_nm_list.replaceAll(',','') : '';
    //             const spTemp = (temp !== '' ? [...new Set(item.inst_nm_list.split(','))] : [])
    //             const spTempFilter = spTemp.filter((item)=>item!=='')
    //             // console.log(spTempFilter)

    //             return {
    //                 ...item,
    //                 set_person: spTempFilter
    //             }
    //         })
    //         setList(temp);
    //     }
    // },[data])

    return (
        <React.Fragment>
            <TitleLine>
                <li>
                    <div style={{textAlign:'left'}}>과업명</div>
                    <div>발주처</div>
                    <div>지점수</div>
                    <div>카메라</div>
                    <div>설치자</div>
                    {/* <div>문의/견적</div> */}
                    <div>설치일</div>
                    <div>촬영시간</div>
                    <div>촬영기간</div>
                    <div>철거일</div>
                    <div>코딩일정</div>
                    {/* <div>코딩진행상황</div> */}
                    <div>코딩진행</div>
                    <div>완료/납품</div>
                </li>
            </TitleLine>
            <SliderWrap>
                <Slider {...setting}>
                {(list && list.length>0)&& 
                        list.map((xItem,xIndex) => {
                            return (
                                <DescArea>
                                { xItem.map((item,index)=>{
                                    return (
                                        <li key={index} className={item.alert===true&&'alertLi'}>
                                            <div className="title_line">&nbsp;
                                                {item.alert===true && <ProjectStatusLabel status={'A'} value={'긴급'}/>}
                                                <ProjectStatusLabel status={item.pro_st} value={item.pro_st_nm}/>
                                                <span className="titleEl">{item.title}</span>
                                            </div>
                                            <div className="title_line">
                                                <span className="titleEl">{item.cname}</span>
                                            </div>
                                            <div className="align">{item.point_cnt}</div>
                                            <div className="align">{item.camera_cnt}</div>
                                            <div className="align">
                                                {item.set_person && item.set_person.map((item,index)=> index>0? ','+item : item)}
                                            </div>
                                            {/* <div><span style={{background: theme.color.request}}>{moment(item.req_from).format('MM/DD')}</span></div> */}
                                            <div className="align">{item.set_from && moment(item.set_from).format('MM/DD(dd)')}<AlertMark to={item.set_from} right={'-1rem'} /></div>
                                            <div className="align">{item.rec_timeH && parseInt(item.rec_timeH,10)}H</div>
                                            <div className="align_twoLine">
                                                {/*20240816 SJK -> see 174line useEffect*/}
                                                {/* {item.rec_list && item.rec_list.map((item,index)=> <span>{item}</span>)} */}
                                                {item.rec_list && item.rec_list.map((item)=> <span>{item}</span>)}
                                                {/* <span>{item.rec_from && moment(item.rec_from).format('MM/DD(dd)')} - 09 ~ 12</span>
                                                <span>{item.rec_to && moment(item.rec_to).format('MM/DD(dd)')} - 09 ~ 12</span> */}
                                                <AlertMark />
                                            </div>
                                            <div className="align">{item.set_to && moment(item.set_to).format('MM/DD(dd)')}<AlertMark to={item.set_to} right={'-1rem'} /></div>
                                            <div className="align_Between">
                                                {item.coding_from && moment(item.coding_from).format('MM/DD(dd)')}-{item.coding_to && moment(item.coding_to).format('MM/DD(dd)')}<AlertMark top={'-0.8rem'}  to={item.coding_to} />
                                            </div>
                                            <div className="align">
                                                { (item.coding_progress && item.coding_progress > 0) ?
                                                <BarBox>
                                                    <BarStyle size={item.coding_progress}>
                                                        <span>{item.coding_progress}%</span>
                                                    </BarStyle>
                                                </BarBox>
                                                :<span/>
                                                }
                                            </div>
                                            <div className="align">{item.odate && moment(item.odate).format('MM/DD(dd)')}</div>
                                        </li>
                                    )})}
                                </DescArea>
                            )
                        }
                    )}
                </Slider>
            </SliderWrap>
        </React.Fragment>
    )
}

export default ScheduleList2;